<template>
  <div class="c-changePassword">
    <div class="o-form">
      <div
        class="o-form__col"
        :class="{ 'o-form__col--error': errors.currentPassword }"
      >
        <div
          class="o-input"
          :class="{
            'o-input--error': errors.currentPassword,
          }"
        >
          <input
            class="o-input__input"
            type="password"
            name="currentPassword"
            id="currentPassword"
            :class="{
              valid: currentPassword,
            }"
            v-model="currentPassword"
          />
          <label for="currentPassword" class="o-input__label">
            {{ translations["Existing password"] }}
          </label>
          <div class="o-input__error" v-if="errors.currentPassword">
            {{ errors.currentPassword[0] }}
          </div>
        </div>
      </div>
    </div>
    <div class="o-form">
      <div
        class="o-form__col"
        :class="{ 'o-form__col--error': errors.newPassword }"
      >
        <div
          class="o-input"
          :class="{
            'o-input--error': errors.newPassword,
          }"
        >
          <input
            class="o-input__input"
            type="password"
            name="newPassword"
            id="newPassword"
            :class="{
              valid: newPassword,
            }"
            v-model="newPassword"
          />
          <label for="newPassword" class="o-input__label">
            {{ translations["New password"] }}
          </label>
          <div class="o-input__error" v-if="errors.newPassword">
            {{ errors.newPassword[0] }}
          </div>
        </div>
      </div>
      <div class="o-form__col">
        <div class="o-input">
          <input
            class="o-input__input"
            type="password"
            name="newPasswordRepeat"
            id="newPasswordRepeat"
            :class="{
              valid: newPasswordRepeat,
            }"
            v-model="newPasswordRepeat"
          />
          <label for="repeatPassword" class="o-input__label">
            {{ translations["Repeat new password"] }}
          </label>
        </div>
      </div>

      <div
        class="c-changePassword__action"
        :class="{
          'c-changePassword__action--error': showError,
          'c-changePassword__action--success': success,
        }"
      >
        <div
          class="c-changePassword__button"
          :class="{ 'c-changePassword__button--loading': isLoading }"
        >
          <div class="o-btn o-btn--filled" @click="updatePassword()">
            {{ translations["Update"] }}
          </div>
          <inline-loader></inline-loader>
        </div>
        <div v-if="showError" class="c-changePassword__error">
          {{ error }}
        </div>
        <div v-if="success" class="c-changePassword__success">
          {{ translations["Password updated succesfully"] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

import InlineLoader from "./InlineLoader.vue";

export default {
  name: "ChangePassword",
  components: {
    InlineLoader,
  },
  props: {
    user: {
      type: Object,
    },
    translations: {
      type: Object,
    },
    csrf: {
      type: String,
    },
  },
  data() {
    return {
      error: "",
      errors: [],
      showError: false,
      isLoading: false,
      currentPassword: "",
      newPassword: "",
      success: false,
      newPasswordRepeat: "",
    };
  },
  methods: {
    updatePassword() {
      if (this.newPassword !== this.newPasswordRepeat) {
        this.showError = true;
        this.error = "Your repeated password doesnt match your new password";
        return;
      }

      if (
        !this.currentPassword ||
        !this.newPassword ||
        !this.newPasswordRepeat
      ) {
        this.showError = true;
        this.error = "All fields must be filled to update password";
        return;
      }

      this.isLoading = true;
      this.showError = false;
      this.error = "";
      this.success = false;

      let formData = new FormData();
      formData.append("action", "users/save-user");
      formData.append("CRAFT_CSRF_TOKEN", this.csrf);
      formData.append("password", this.currentPassword);
      formData.append("newPassword", this.newPassword);
      formData.append("userId", this.user.id);

      axios
        .post(document.location.href, formData)
        .then((response) => {
          this.isLoading = false;

          // console.log(response)

          if (response.data.success) {
            this.errors = [];
            this.success = true;
            this.$store.commit(
              "app/setCsrfToken",
              response.data.csrfTokenValue
            );
          }

          if (response.data.errors) {
            this.showError = true;
            this.success = false;
            this.error = "We could not update your password";
            this.errors = response.data.errors;
          }
        })
        .catch((error) => {
          // console.log(error.response)
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../scss/base/variables.scss";

.c-changePassword {
  .o-input {
    margin-bottom: 12px;
  }
  &__action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: 100%;

    &--error,
    &--success {
      &::before {
        display: block;
        position: absolute;
        content: "";
        top: -4px;
        right: -4px;
        bottom: -4px;
        left: -4px;
        z-index: -1;
      }
    }

    &--error {
      &::before {
        background: #ffeded;
        border: 1px solid #a1160f;
      }
    }

    &--success {
      &::before {
        background: #edfff6;
        border: 1px solid #0fa15b;
      }
    }
  }

  &__error,
  &__success {
    margin-left: 10px;
    margin-right: 10px;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: -0.12px;
  }

  &__error {
    color: #a1160f;
  }

  &__success {
    color: #0fa15b;
  }

  &__button {
    position: relative;

    .o-btn {
      white-space: nowrap;
    }

    .o-loaderInline {
      display: none;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-left: -22px;
      z-index: 3;
      div {
        background: $c-white;
      }
    }

    &--loading {
      &::before {
        position: absolute;
        z-index: 2;
        display: block;
        background: $brand-orange;
        content: "";
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      .o-loaderInline {
        display: inline-block;
      }
    }
  }
}
</style>
